/*
 * BIOSHOTS PLAN CARDS v5.4 - INLINE ATC BUTTONS
 * - Knop onder geselecteerde kaart
 * - Zelfde checkout logica als hoofdknop
 * - bioshots:plan-selected event voor sticky ATC sync
 * - Cadeaus worden NA de knop geplaatst
 */

console.log('✅ bioshots-plan-cards.js v5.4 loaded at:', new Date().toLocaleTimeString());

(function() {
  const SHOTGLASS_VARIANT_ID = '51556485562710';
  const SCOOP_VARIANT_ID = '51557504811350';
  
  function qs(r, s) { return (r || document).querySelector(s); }
  function qsa(r, s) { return Array.from((r || document).querySelectorAll(s)); }

  function getSectionEl(container) {
    const sectionId = container.getAttribute('data-section-id');
    return document.querySelector(`#shopify-section-${sectionId}`) || container.closest('[id^="shopify-section-"]') || document;
  }
  
  function getForms(sectionEl) { 
    return qsa(sectionEl, '[action*="/cart/add"]'); 
  }
  
  function getVariantInput(forms, sectionEl) {
    if (!forms || !forms.length) return null;
    for (const f of forms) {
      try {
        if (sectionEl && sectionEl.contains(f) && f.querySelector('input[name="selling_plan"]'))
          return f.querySelector('select[name="id"], input[name="id"]');
      } catch (e) {}
    }
    for (const f of forms) {
      try {
        if (sectionEl && sectionEl.contains(f))
          return f.querySelector('select[name="id"], input[name="id"]');
      } catch (e) {}
    }
    return null;
  }

  function setVariant(variantInput, id) {
    if (!variantInput) return;
    try {
      const tag = variantInput.tagName.toLowerCase();
      variantInput.value = id;
      variantInput.dispatchEvent(new Event(tag === 'select' ? 'change' : 'input', { bubbles: true }));
      if (tag !== 'select') variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) {}
  }

  function setSellingPlanOnForms(sectionEl, spId) {
    const forms = getForms(sectionEl);
    const targetForm = (forms || []).find(f => sectionEl && sectionEl.contains(f)) || forms[0];
    if (!targetForm) return;

    try {
      Array.from(targetForm.querySelectorAll('input[name="selling_plan"]')).forEach(inp => {
        if (!inp.value || String(inp.value).trim() === '') inp.parentNode?.removeChild(inp);
      });
    } catch(e){}

    let inp = targetForm.querySelector('input[name="selling_plan"]');
    if (!inp) { inp = document.createElement('input'); inp.type = 'hidden'; inp.name = 'selling_plan'; targetForm.appendChild(inp); }
    inp.value = spId || '';

    let inp2 = targetForm.querySelector('input[name="selling_plan_id"]');
    if (!inp2) { inp2 = document.createElement('input'); inp2.type = 'hidden'; inp2.name = 'selling_plan_id'; targetForm.appendChild(inp2); }
    inp2.value = spId || '';
  }
  
  function allocationRadios(sectionEl, variantId) { 
    const section = qs(sectionEl, `section[data-variant-id="${variantId}"]`);
    if (!section) return [];
    return qsa(section, 'input[type="radio"][data-radio-type="selling_plan"]');
  }
  
  function oneTimeRadio(sectionEl, variantId) { 
    return qs(sectionEl, `section[data-variant-id="${variantId}"] input[type="radio"][data-radio-type="one_time_purchase"]`); 
  }

  function parseCfg(container) {
    try { return JSON.parse(qs(container, '.bioshots-plans-json').textContent); }
    catch (e) { return { ids:{}, labels:{monthly:[],biMonthly:[]}, nativeSellingPlanIds:[], variants:{} }; }
  }

  function pickPlanId(radios, cadence, cfg) {
    if (!radios || radios.length === 0) return null;
    const configKey = cadence === 'bi-monthly' ? 'biMonthly' : cadence;
    const direct = cfg?.ids?.[configKey];
    if (direct) return String(direct);

    const nativeSet = new Set((cfg?.nativeSellingPlanIds) || []);
    const labels = cadence === 'monthly' ? (cfg.labels?.monthly || []) : (cfg.labels?.biMonthly || []);

    const found = radios.find(r => {
      const spNumeric = String(r.dataset?.sellingPlanId || r.value || r.getAttribute('data-selling-plan-id') || '').trim();
      if (!spNumeric) return false;
      if (nativeSet.size > 0 && !nativeSet.has(spNumeric) && !nativeSet.has(`gid://shopify/SellingPlan/${spNumeric}`)) return false;
      const label = ((r.getAttribute('aria-label') || '') + ' ' + (r.nextElementSibling?.textContent || '')).toLowerCase();
      if (labels.length > 0) return labels.some(k => label.replace(/-/g,' ').includes(String(k).toLowerCase().replace(/-/g,' ')));
      return true;
    });

    if (!found) return null;
    return String(found.dataset?.sellingPlanId || found.value || found.getAttribute('data-selling-plan-id') || '');
  }

  function checkPlanRadio(sectionEl, variantId, type, spId) {
    const base = qs(sectionEl, `section[data-variant-id="${variantId}"]`);
    if (!base) return;
    const radio = type === 'onetime'
      ? qs(base, 'input[type="radio"][data-radio-type="one_time_purchase"]')
      : qs(base, `input[type="radio"][data-radio-type="selling_plan"][data-selling-plan-id="${spId}"]`);
    if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  function getCentsFromRadio(r, key) {
    if (!r) return null;
    const dv = r?.dataset?.[key];
    if (dv && !isNaN(Number(dv))) return Number(dv);
    const av = r.getAttribute(`data-${key.replace(/([A-Z])/g,'-$1').toLowerCase()}`);
    if (av && !isNaN(Number(av))) return Number(av);
    if (key === 'variantPriceCents') {
      const fp = r.dataset?.variantPrice || r.getAttribute('data-variant-price');
      if (fp) {
        const m = fp.match(/[\d,]+/);
        if (m) { const c = Math.round(parseFloat(m[0].replace(',','.')) * 100); if (!isNaN(c)) return c; }
      }
    }
    return null;
  }
  
  function formatMoneyEUR(cents) {
    if (cents == null) return '';
    try { return (cents/100).toLocaleString('nl-NL',{style:'currency',currency:'EUR'}); }
    catch(e) { return '€' + (cents/100).toFixed(2).replace('.',','); }
  }
  
  function percentOff(p, c) {
    if (!p || !c || c <= p) return null;
    return Math.round((1 - p/c) * 100);
  }

  function priceDataOnetime(sectionEl, variantId) {
    const r = oneTimeRadio(sectionEl, variantId);
    if (!r) return { display:'', priceCents:null, compareCents:null };
    return { display: r.dataset.variantPrice || '', priceCents: getCentsFromRadio(r,'variantPriceCents'), compareCents: getCentsFromRadio(r,'variantCompareAtPriceCents') };
  }

  function priceDataCadence(sectionEl, variantId, cadence, cfg) {
    const radios = allocationRadios(sectionEl, variantId);
    const spId = pickPlanId(radios, cadence, cfg);
    if (!spId) return { display:'', priceCents:null, compareCents:null, totalDisplay:'' };
    const r = qs(sectionEl, `section[data-variant-id="${variantId}"] input[type="radio"][data-radio-type="selling_plan"][data-selling-plan-id="${spId}"]`);
    if (!r) return { display:'', priceCents:null, compareCents:null, totalDisplay:'' };
    const priceCents = getCentsFromRadio(r,'variantPriceCents');
    const compareCents = getCentsFromRadio(r,'variantCompareAtPriceCents');
    if (cadence === 'bi-monthly' && priceCents) {
      const pmc = Math.round(priceCents/2);
      return { display: formatMoneyEUR(pmc), priceCents, compareCents, totalDisplay: formatMoneyEUR(priceCents) + ' per 2 maanden' };
    }
    return { display: r.dataset.variantPrice || formatMoneyEUR(priceCents), priceCents, compareCents, totalDisplay:'' };
  }

  function updateCardPrices(sectionEl, container, cfg) {
    qsa(container, '.bioshots-card').forEach(card => {
      const vId = card.dataset.variantId;
      const planType = card.dataset.planType;
      const cadence = card.dataset.planCadence;
      const data = planType === 'onetime' ? priceDataOnetime(sectionEl, vId) : priceDataCadence(sectionEl, vId, cadence, cfg);
      const priceEl = qs(card, '.js-card-price');
      if (priceEl) priceEl.textContent = data.display || '';
      const saveEl = qs(card, '.js-card-save');
      if (saveEl) {
        const pct = percentOff(data.priceCents, data.compareCents);
        saveEl.textContent = (pct > 0) ? `-${pct}%` : '';
        saveEl.style.display = (pct > 0) ? 'inline-block' : 'none';
      }
      const totalEl = qs(card, '.js-card-total');
      if (totalEl) { totalEl.textContent = data.totalDisplay || ''; totalEl.style.display = data.totalDisplay ? 'block' : 'none'; }
    });
  }

  function updateGiftVisibility(container, planType, cadence) {
    const giftsContainer = qs(document, '.bioshots-gifts-container');
    if (!giftsContainer) return;
    const shotglassBlock = qs(giftsContainer, '.bioshots-gift-block--shotglass');
    const scoopBlock = qs(giftsContainer, '.bioshots-gift-block--scoop');
    if (shotglassBlock) { shotglassBlock.classList.add('is-visible'); shotglassBlock.style.display = 'block'; }
    if (scoopBlock) {
      const show = planType === 'subscription' && cadence === 'bi-monthly';
      scoopBlock.classList.toggle('is-visible', show);
      scoopBlock.style.display = show ? 'block' : 'none';
    }
  }

  function moveGiftsToActiveCard(container) {
    const giftsContainer = qs(document, '.bioshots-gifts-container');
    if (!giftsContainer) return;

    const selectedCard = qs(container, '.bioshots-card.is-selected');
    if (!selectedCard) return;

    const wrap = selectedCard.closest('.bioshots-cardwrap');
    if (!wrap) return;

    // Verplaats giftsContainer naar NA de ATC knop
    const atcBtn = qs(wrap, '.bioshots-card__atc-btn');
    if (atcBtn) {
      atcBtn.insertAdjacentElement('afterend', giftsContainer);
    } else {
      wrap.appendChild(giftsContainer);
    }
  }

  // ---- CHECKOUT ----
  async function handleCheckoutWithGifts(sectionEl, planType, cadence, submitButton) {
    const forms = getForms(sectionEl);
    const targetForm = (forms || []).find(f => sectionEl && sectionEl.contains(f)) || forms[0];
    if (!targetForm) return;

    const originalHTML = submitButton ? submitButton.innerHTML : '';
    if (submitButton) {
      const labelEl = submitButton.querySelector('.bioshots-card__atc-btn-label');
      const loadEl  = submitButton.querySelector('.bioshots-card__atc-btn-loading');
      if (labelEl) labelEl.style.display = 'none';
      if (loadEl)  loadEl.style.display = 'flex';
      submitButton.disabled = true;
    }

    try {
      const formData = new FormData(targetForm);
      const variantId   = formData.get('id');
      const quantity    = parseInt(formData.get('quantity')) || 1;
      const sellingPlan = formData.get('selling_plan');

      if (!variantId) throw new Error('No variant ID found in form');
      if (planType === 'subscription' && !sellingPlan) throw new Error('Subscription selected but no selling plan ID found');

      if (planType === 'subscription' && cadence === 'bi-monthly') {
        window.biMonthlyVariants = window.biMonthlyVariants || [];
        if (!window.biMonthlyVariants.includes(variantId)) window.biMonthlyVariants.push(variantId);
        try {
          const saved = sessionStorage.getItem('bioshots_bimonthly_variants');
          const variants = saved ? JSON.parse(saved) : [];
          if (!variants.includes(variantId)) { variants.push(variantId); sessionStorage.setItem('bioshots_bimonthly_variants', JSON.stringify(variants)); }
        } catch(e) {}
      }

      const mainBody = { id: variantId, quantity };
      if (sellingPlan) mainBody.selling_plan = sellingPlan;

      const mainRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(mainBody)
      });
      if (!mainRes.ok) throw new Error('Failed to add main product: ' + await mainRes.text());

      await new Promise(r => setTimeout(r, 400));

      const cart = await fetch('/cart.js').then(r => r.json());
      const hasShotglass = cart.items.some(i => String(i.variant_id) === SHOTGLASS_VARIANT_ID);
      const hasScoop     = cart.items.some(i => String(i.variant_id) === SCOOP_VARIANT_ID);

      if (!hasShotglass) {
        await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ id: SHOTGLASS_VARIANT_ID, quantity:1, properties:{'_gift':'Gratis cadeau','_parent_variant':variantId} }) });
        await new Promise(r => setTimeout(r, 300));
      }

      if (planType === 'subscription' && cadence === 'bi-monthly' && !hasScoop) {
        await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ id: SCOOP_VARIANT_ID, quantity:1, properties:{'_gift':'Extra gratis bij 2-maands abonnement','_parent_variant':variantId} }) });
      }

      await new Promise(r => setTimeout(r, 300));
      window.location.href = '/cart';

    } catch (error) {
      console.error('❌ Checkout error:', error);
      if (submitButton) {
        submitButton.innerHTML = originalHTML;
        submitButton.disabled = false;
      }
      alert('Er ging iets mis. Probeer het opnieuw: ' + error.message);
    }
  }

  function setupCartIntegration(sectionEl, container) {
    const forms = getForms(sectionEl);
    const targetForm = (forms || []).find(f => sectionEl && sectionEl.contains(f)) || forms[0];
    if (!targetForm || targetForm.dataset.cartIntegrationAdded) return;
    targetForm.dataset.cartIntegrationAdded = 'true';

    const buyButton = document.querySelector('x-buy-button, .x-product-buy-button, button[name="add"]');
    if (buyButton) {
      buyButton.addEventListener('click', async function(e) {
        const selectedCard = qs(container, '.bioshots-card.is-selected');
        if (!selectedCard) return;
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        await handleCheckoutWithGifts(sectionEl, selectedCard.dataset.planType, selectedCard.dataset.planCadence, buyButton);
      }, true);
    }
  }

  function initBioshotsPlanCards() {
    qsa(document, '.bioshots-plan-cards').forEach(container => {
      const sectionEl = getSectionEl(container);
      if (!sectionEl) return;

      const forms = getForms(sectionEl);
      const variantInput = getVariantInput(forms, sectionEl);
      const cfg = parseCfg(container);

      setupCartIntegration(sectionEl, container);

      // ---- INLINE ATC BUTTONS ----
      qsa(container, '.js-card-atc-btn').forEach(atcBtn => {
        atcBtn.addEventListener('click', async function(e) {
          e.preventDefault();
          e.stopPropagation();
          const wrap = atcBtn.closest('.bioshots-cardwrap');
          const card = wrap ? qs(wrap, '.bioshots-card') : null;
          if (!card) return;
          const planType = card.dataset.planType;
          const cadence  = card.dataset.planCadence;
          await handleCheckoutWithGifts(sectionEl, planType, cadence, atcBtn);
        });
      });

      // ---- DEFAULT CARD ----
      const defaultCard = qs(container, '.bioshots-card.is-selected');
      if (defaultCard && !defaultCard.disabled) {
        const vId = defaultCard.dataset.variantId;
        const planType = defaultCard.dataset.planType;
        const cadence = defaultCard.dataset.planCadence;
        setVariant(variantInput, vId);
        moveGiftsToActiveCard(container);
        setTimeout(() => {
          if (planType === 'subscription') {
            const spId = pickPlanId(allocationRadios(sectionEl, vId), cadence, cfg);
            setSellingPlanOnForms(sectionEl, spId);
            checkPlanRadio(sectionEl, vId, 'subscription', spId);
          } else {
            setSellingPlanOnForms(sectionEl, null);
            checkPlanRadio(sectionEl, vId, 'onetime', null);
          }
          updateCardPrices(sectionEl, container, cfg);
          updateGiftVisibility(container, planType, cadence);
          document.dispatchEvent(new CustomEvent('bioshots:plan-selected'));
        }, 300);
      }

      // ---- CARD CLICKS ----
      qsa(container, '.bioshots-card').forEach(card => {
        if (card.disabled) { card.classList.add('is-disabled'); return; }

        card.addEventListener('click', () => {
          const vId = card.dataset.variantId;
          const planType = card.dataset.planType;
          const cadence = card.dataset.planCadence;

          setVariant(variantInput, vId);
          qsa(container, '.bioshots-card').forEach(c => c.classList.remove('is-selected'));
          card.classList.add('is-selected');
          moveGiftsToActiveCard(container);
          updateGiftVisibility(container, planType, cadence);

          setTimeout(() => {
            if (planType === 'subscription') {
              const spId = pickPlanId(allocationRadios(sectionEl, vId), cadence, cfg);
              setSellingPlanOnForms(sectionEl, spId);
              checkPlanRadio(sectionEl, vId, 'subscription', spId);
            } else {
              setSellingPlanOnForms(sectionEl, null);
              checkPlanRadio(sectionEl, vId, 'onetime', null);
            }
            updateCardPrices(sectionEl, container, cfg);
            document.dispatchEvent(new CustomEvent('bioshots:plan-selected'));
          }, 300);
        });

        card.setAttribute('role', 'radio');
        card.setAttribute('tabindex', '0');
        card.addEventListener('keydown', e => { if (e.key==='Enter'||e.key===' ') { e.preventDefault(); card.click(); } });
      });

      if (variantInput) {
        variantInput.addEventListener('change', () => setTimeout(() => updateCardPrices(sectionEl, container, cfg), 200));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBioshotsPlanCards);
  } else {
    initBioshotsPlanCards();
  }
})();